import * as React from "react";
import {connect} from "react-redux";
import {Action, Dispatch} from "redux";

import {Pager} from "../../domain/model/common";
import {Customer} from "../../domain/model/customer";

import {createClientScoutCustomerListActionCreator} from "../action/client_scout_customers_action";
import {
    createScoutCustomerListDispatcher,
    IClientScoutCustomerListDispatcher,
} from "../dispatcher/client_scout_customers_dispatcher";
import {AppState} from "../store/app_state";
import {ClientScoutCustomerListState} from "../store/client_scout_customers_state";

import {CopyHighlightsByClientRequest, SearchCustomerListByClientRequest,} from "../request/scout_request";

import {RouteComponentProps} from "react-router";
import {AuthState} from "src/presentation/store/auth_state";
import {frontEndConfig} from "../../config/config";
import {Client} from "../../domain/model/client";
import {Company} from "../../domain/model/company";
import {api, entity} from "../../infra/api/rpc/api";
import {createClientScoutCustomerActionCreator} from "../action/client_scout_customer_action";
import {createSkillTagActionCreator} from "../action/skill_tag_action";
import ScoutCustomersComponent from "../component/client/scout_customers/client_scout_customers";
import {
    createScoutCustomerDispatcher,
    IClientScoutCustomerDispatcher,
} from "../dispatcher/client_scout_customer_dispatcher";
import {createSkillTagDispatcher} from "../dispatcher/skill_tag_dispatcher";
import {TPagination, TSearchQueryForScoutCustomers} from "../type/common";

const defaultOffset = frontEndConfig.defaultOffset;
const pageRangeDisplayed: number = frontEndConfig.defaultPageRangeDisplayed;

interface IProps extends RouteComponentProps<{}> {
    authState: AuthState;
    state: ClientScoutCustomerListState;
    dispatcher: IClientScoutCustomerListDispatcher;
    scoutCustomerDispatcher: IClientScoutCustomerDispatcher;
}

interface IState {
    isInit: boolean;
}

export class ClientScoutCustomers extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isInit: true,
        };
    }

    public componentDidMount() {
        // 直接アクセスの際のデータ取得
        const params: TSearchQueryForScoutCustomers = this.helperForSearchPrams(
            this.props.location.search
        );

        this.pushQueryString(params);
    }

    public componentWillReceiveProps(
        nextProps: Readonly<IProps>,
        nextContext: any
    ): void {
        // URL遷移の際のデータ取得
        if (nextProps.location !== this.props.location) {
            const params: TSearchQueryForScoutCustomers = this.helperForSearchPrams(
                nextProps.location.search
            );
            const pager: Pager = new Pager(params.activePage, defaultOffset);
            const req: SearchCustomerListByClientRequest =
                new SearchCustomerListByClientRequest();
            req.pager = pager;
            req.query = params.query;
            if (params.otc) {
                const str =
                    entity.OccupationSkillTag.Category[parseInt(params.otc, undefined)];
                const category: entity.OccupationSkillTag.Category =
                    entity.OccupationSkillTag.Category[
                        str as keyof typeof entity.OccupationSkillTag.Category
                        ];
                req.occupationSkillTagCategory = category;
            }
            if (params.otp && !params.ot) {
                req.occupationSkillTagId = params.otp;
            }
            if (params.otp && params.ot) {
                req.occupationSkillTagId = params.ot;
            }
            req.singleSkillTagIDs = [params.st1, params.st2].filter((item) => !!item);
            req.multiSkillTagIDs = [
                params.mt,
                params.mt1,
                params.mt2,
                params.mt3,
                params.mt4,
            ].filter((item) => !!item);

            switch (params.gender) {
                case "1":
                    req.gender = entity.User.Gender.Gender_Male;
                    break;
                case "2":
                    req.gender = entity.User.Gender.Gender_Female;
                    break;
                default:
                    req.gender = entity.User.Gender.Gender_Unknown;
                    break;
            }

            switch (params.age) {
                case "1":
                    req.age = api.CustomerAgeSearchType.Under30;
                    break;
                case "2":
                    req.age = api.CustomerAgeSearchType.From30To40;
                    break;
                case "3":
                    req.age = api.CustomerAgeSearchType.From40To50;
                    break;
                case "4":
                    req.age = api.CustomerAgeSearchType.From50To60;
                    break;
                case "5":
                    req.age = api.CustomerAgeSearchType.Over60;
                    break;
                default:
                    req.age = api.CustomerAgeSearchType.Unknown;
                    break;
            }

            switch (params.wi) {
                case "1":
                    req.workIntention =
                        entity.Customer.WorkIntention.WorkIntention_OnlyAdvice;
                    break;
                case "2":
                    req.workIntention =
                        entity.Customer.WorkIntention.WorkIntention_WithWork;
                    break;
                case "3":
                    req.workIntention =
                        entity.Customer.WorkIntention.WorkIntention_Consultation_Required;
                    break;
                default:
                    req.workIntention =
                        entity.Customer.WorkIntention.WorkIntention_Unknown;
                    break;
            }

            switch (params.ft) {
                case "1":
                    req.fullTimePossibility =
                        entity.Customer.FullTimePossibility.FullTimePossibility_Yes;
                    break;
                case "2":
                    req.fullTimePossibility =
                        entity.Customer.FullTimePossibility.FullTimePossibility_No;
                    break;
                default:
                    req.fullTimePossibility =
                        entity.Customer.FullTimePossibility.FullTimePossibility_Unknown;
                    break;
            }

            const client: Client | null = this.props.authState.user
                ? this.props.authState.user.client
                : null;
            const company: Company | null = this.props.authState.company;

            if (client && company) {
                const event_name = "client_search_customer";
                const event_params = {
                    query: req.query,
                    client_id: client.id,
                    client_name: client!.name,
                    client_email: this.props.authState.user!.email,
                    company_id: company!.id,
                    company_name: company!.name,
                };

                if (window.gtag) {

                    window.gtag("event", event_name, event_params);
                }
            }

            this.props.dispatcher.searchCustomerList(req);
        }
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // init処理の終了
        const isInitFinished: boolean =
            this.state.isInit &&
            !this.props.state.isLoading &&
            prevProps.state.isLoading;
        if (isInitFinished) {
            this.setState({isInit: false});
        }
    }

    public render(): JSX.Element {
        const {location, state} = this.props;
        const {isInit} = this.state;

        const {
            customers,
            customerCount,
            jobCareersWithCustomerID,
            clientBookmarks,
        } = state;

        const totalItemsCount: number = state.customerCount;
        const isLoading: boolean = state.isLoading;
        const itemsCountPerPage: number = defaultOffset;

        const params: TSearchQueryForScoutCustomers = this.helperForSearchPrams(
            location.search
        );

        const isSearch: boolean =
            params.query !== "" ||
            params.otc !== "" ||
            params.otp !== "" ||
            params.ot !== "" ||
            params.st1 !== "" ||
            params.st2 !== "" ||
            params.mt1 !== "" ||
            params.mt2 !== "" ||
            params.mt3 !== "" ||
            params.mt4 !== "" ||
            params.mt !== "" ||
            params.gender !== "" ||
            params.age !== "" ||
            params.wi !== "" ||
            params.ft !== "";

        const hasSearchQuery = !!params.query;

        const paginationPrams: TPagination = {
            activePage: params.activePage,
            itemsCountPerPage,
            totalItemsCount,
            pageRangeDisplayed,
            onChange: this.handlePageChange,
        };

        return (
            <ScoutCustomersComponent
                isSearch={isSearch}
                isInit={isInit}
                isLoading={isLoading}
                customers={customers}
                customerCount={customerCount}
                hasSearchQuery={hasSearchQuery}
                jobCareersWithCustomerID={jobCareersWithCustomerID}
                clientBookmarks={clientBookmarks}
                searchFormInitValues={{
                    q: params.query,
                    occupationCategory: params.otc,
                    occupationParent: params.otp,
                    occupationSkillTag: params.ot,
                    singlePhaseTag: params.st1,
                    singleServiceClassificationTag: params.st2,
                    multiGyokaiTag: params.mt1,
                    multiCXOTag: params.mt2,
                    multiOverseaTag: params.mt3,
                    multiOtherTag: params.mt4,
                    multiSkillTag: params.mt,
                    multiSkillTagCategory: params.mc,
                    gender: params.gender,
                    age: params.age,
                    workIntention: params.wi,
                    fullTimePossibility: params.ft,
                }}
                paginationPrams={paginationPrams}
                // handleSearch={this.handleSearch}
                handleDetailSearch={this.handleDetailSearch}
                handleClickLink={this.handleClickLink}
                onResetSearch={this.handleResetSearch}
            />
        );
    }

    private helperForSearchPrams = (
        urlSearchParams: any
    ): TSearchQueryForScoutCustomers => {
        const params = new URLSearchParams(urlSearchParams);
        const occupationRawCategory: string = params.get("otc") || "";
        const occupationParent: string = params.get("otp") || "";
        const occupationSkillTagId: string = params.get("ot") || "";
        const singlePhaseTag: string = params.get("st1") || "";
        const singleServiceClassificationTag: string = params.get("st2") || "";
        const multiGyokaiTag: string = params.get("mt1") || "";
        const multiSkillTagId2: string = params.get("mt2") || "";
        const multiSkillTagId3: string = params.get("mt3") || "";
        const multiSkillTagId4: string = params.get("mt4") || "";
        const multiSkillTagId: string = params.get("mt") || "";
        const multiSkillTagCategory: string = params.get("mc") || "";
        const query: string = params.get("q") ? String(params.get("q")) : "";
        const gender: string = params.get("gender")
            ? String(params.get("gender"))
            : "";
        const age: string = params.get("age") ? String(params.get("age")) : "";
        const workIntention: string = params.get("wi")
            ? String(params.get("wi"))
            : "";
        const fullTimePossibility: string = params.get("ft")
            ? String(params.get("ft"))
            : "";
        let activePage: number = params.get("p") ? Number(params.get("p")) : 1;
        if (Number.isNaN(activePage)) {
            activePage = 1;
        }

        const res: TSearchQueryForScoutCustomers = {
            query,
            activePage,
            otc: occupationRawCategory,
            otp: occupationParent,
            ot: occupationSkillTagId,
            st1: singlePhaseTag,
            st2: singleServiceClassificationTag,
            mt1: multiGyokaiTag,
            mt2: multiSkillTagId2,
            mt3: multiSkillTagId3,
            mt4: multiSkillTagId4,
            mt: multiSkillTagId,
            mc: multiSkillTagCategory,
            gender,
            age,
            wi: workIntention,
            ft: fullTimePossibility,
        };
        return res;
    };

    private pushQueryString = (
        searchQuery: TSearchQueryForScoutCustomers
    ): void => {
        const {location, history} = this.props;
        const params = new URLSearchParams(location.search);
        searchQuery.otc
            ? params.set("otc", String(searchQuery.otc))
            : params.delete("otc");
        searchQuery.otp
            ? params.set("otp", String(searchQuery.otp))
            : params.delete("otp");
        searchQuery.ot
            ? params.set("ot", String(searchQuery.ot))
            : params.delete("ot");
        searchQuery.st1
            ? params.set("st1", String(searchQuery.st1))
            : params.delete("st1");
        searchQuery.st2
            ? params.set("st2", String(searchQuery.st2))
            : params.delete("st2");
        searchQuery.mt1
            ? params.set("mt1", String(searchQuery.mt1))
            : params.delete("mt1");
        searchQuery.mt2
            ? params.set("mt2", String(searchQuery.mt2))
            : params.delete("mt2");
        searchQuery.mt3
            ? params.set("mt3", String(searchQuery.mt3))
            : params.delete("mt3");
        searchQuery.mt4
            ? params.set("mt4", String(searchQuery.mt4))
            : params.delete("mt4");
        searchQuery.mt
            ? params.set("mt", String(searchQuery.mt))
            : params.delete("mt");
        searchQuery.mc
            ? params.set("mc", String(searchQuery.mc))
            : params.delete("mc");
        params.set("q", String(searchQuery.query));
        params.set("gender", String(searchQuery.gender));
        params.set("age", String(searchQuery.age));
        searchQuery.wi
            ? params.set("wi", String(searchQuery.wi))
            : params.delete("wi");
        searchQuery.ft
            ? params.set("ft", String(searchQuery.ft))
            : params.delete("ft");
        params.set("p", searchQuery.activePage.toString());

        history.push({
            search: params.toString(),
        });
    };

    private handlePageChange = (pageNumber: number): void => {
        const params = new URLSearchParams(this.props.location.search);

        const occupationRawCategory: string = params.get("otc") || "";
        const occupationParent: string = params.get("otp") || "";
        const occupationSkillTagId: string = params.get("ot") || "";
        const singleSkillTagId1: string = params.get("st1") || "";
        const singleSkillTagId2: string = params.get("st2") || "";
        const multiSkillTagId1: string = params.get("mt1") || "";
        const multiSkillTagId2: string = params.get("mt2") || "";
        const multiSkillTagId3: string = params.get("mt3") || "";
        const multiSkillTagId4: string = params.get("mt4") || "";
        const multiSkillTagId: string = params.get("mt") || "";
        const multiSkillTagCategory: string = params.get("mc") || "";
        const query: string = params.get("q") ? String(params.get("q")) : "";
        const gender: string = params.get("gender")
            ? String(params.get("gender"))
            : "";
        const age: string = params.get("age") ? String(params.get("age")) : "";
        const workIntention: string = params.get("wi")
            ? String(params.get("wi"))
            : "";
        const fullTimePossibility: string = params.get("ft")
            ? String(params.get("ft"))
            : "";
        const activePage: number = pageNumber;

        const searchQuery: TSearchQueryForScoutCustomers = {
            query,
            activePage,
            otc: occupationRawCategory,
            otp: occupationParent,
            ot: occupationSkillTagId,
            st1: singleSkillTagId1,
            st2: singleSkillTagId2,
            mt1: multiSkillTagId1,
            mt2: multiSkillTagId2,
            mt3: multiSkillTagId3,
            mt4: multiSkillTagId4,
            mt: multiSkillTagId,
            mc: multiSkillTagCategory,
            gender,
            age,
            wi: workIntention,
            ft: fullTimePossibility,
        };
        this.pushQueryString(searchQuery);
    };

    private handleDetailSearch = (values: any): void => {
        const params = new URLSearchParams(this.props.location.search);

        const query: string = values.q ? values.q : "";
        const occupationCategory: string = values.occupationCategory || "";
        const occupationParent: string = values.occupationParent || "";
        const occupationSkillTagId: string = values.occupationSkillTag || "";
        const singlePhaseTag: string = values.singlePhaseTag || "";
        const singleServiceClassificationTag: string =
            values.singleServiceClassificationTag || "";
        const multiGyokaiTag: string = values.multiGyokaiTag || "";
        const multiCXOTag: string = values.multiCXOTag || "";
        const multiOverseaTag: string = values.multiOverseaTag || "";
        const multiOtherTag: string = values.multiOtherTag || "";
        const gender: string = values.gender || "";
        const age: string = values.age || "";
        const workIntention: string = values.workIntention || "";
        const fullTimePossibility: string = values.fullTimePossibility || "";

        const activePage: number = 1;

        const searchQuery: TSearchQueryForScoutCustomers = {
            query,
            activePage,
            otc: occupationCategory,
            otp: occupationParent,
            ot: occupationSkillTagId,
            st1: singlePhaseTag,
            st2: singleServiceClassificationTag,
            mt1: multiGyokaiTag,
            mt2: multiCXOTag,
            mt3: multiOverseaTag,
            mt4: multiOtherTag,
            mt: "",
            mc: "",
            gender,
            age,
            wi: workIntention,
            ft: fullTimePossibility,
        };
        this.pushQueryString(searchQuery);
    };

    private handleResetSearch = (): void => {
        const params = new URLSearchParams(this.props.location.search);

        const query: string = params.get("q") ? String(params.get("q")) : "";

        const activePage: number = 1;

        const searchQuery: TSearchQueryForScoutCustomers = {
            query,
            activePage,
            otc: "",
            otp: "",
            ot: "",
            st1: "",
            st2: "",
            mt1: "",
            mt2: "",
            mt3: "",
            mt4: "",
            mt: "",
            mc: "",
            gender: "",
            age: "",
            wi: "",
            ft: "",
        };
        this.pushQueryString(searchQuery);
    };

    private handleClickLink =
        (customer: Customer) =>
            (event: any): void => {
                const req: CopyHighlightsByClientRequest =
                    new CopyHighlightsByClientRequest();
                req.highlights = customer.highlights;
                this.props.scoutCustomerDispatcher.copyHighlights(req);
            };
}

const mapStateToProps = (state: AppState) => {
    return {
        authState: state.authReducer,
        state: state.clientScoutCustomerListReducer,
        skillTagState: state.skillTagReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createScoutCustomerListDispatcher(
            dispatch,
            createClientScoutCustomerListActionCreator()
        ),
        scoutCustomerDispatcher: createScoutCustomerDispatcher(
            dispatch,
            createClientScoutCustomerActionCreator()
        ),
        skillTagDispatcher: createSkillTagDispatcher(
            dispatch,
            createSkillTagActionCreator()
        ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientScoutCustomers);



// WEBPACK FOOTER //
// ./src/presentation/container/client_scout_customers_container.tsx